export default {
    state: {
        loading: false,
        platform: '', // 用户平台所在平台 WX：微信 IPH：苹果 ADR：安卓  PC：电脑
        isWechat: false, // 是否为微信平台
        isAndroid: false, // 是否为安卓平台
        openId: (new Date()).valueOf(), // 默认openId
    },
    getters: {
        loading: state => state.loading,
        // 用户平台所在平台
        platform: state => state.platform,
        // 是否是微信登录的
        isWechat(state) {
            return state.isWechat
        },
        // 是否为安卓平台
        isAndroid: state => state.isAndroid,
        //openId
        openId: state => state.openId,
    },
    mutations: {
        // 设置平台信息
        setPlatform(state) {
            try {
                const userAgent = navigator.userAgent;
                const isWechat = /MicroMessenger/i.test(userAgent);
                if (isWechat) {
                    state.platform = 'WX';
                    state.isWechat = true;
                } else {
                    const isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Linux') > -1;
                    const isIOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                    if (isIOS) {
                        state.platform = 'IPH';
                    } else if (isAndroid) {
                        state.platform = 'ADR';
                        state.isAndroid = true;
                    } else {
                        state.platform = 'PC';
                    }
                }
            } catch (error) {
                state.platform = '';
                state.isWechat = false;
                state.isAndroid = false;
            }
        },
        // 展示加载页面
        showLoad(state) {
            state.loading = true;
        },
        // 隐藏加载页面
        hideLoad(state) {
            state.loading = false;
        },
    },
    actions: {
        // 初始化
        init({
            state,
            commit,
            dispatch
        }) {
            // 获取平台信息
            commit('setPlatform');

            dispatch('user/init')

        }
    },
};


// WEBPACK FOOTER //
// ./src/store/modules/base.js